import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Info } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";

import {
  Edit,
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

const initialValuesFromDb = {
  bowls: [
    {
      bowl: {
        value: "A",
        confidence: 80,
      },
      consumed_material_number: {
        value: "1800005004",
        confidence: 90,
      },
      actual_component_quantity_consumed: {
        value: "226.0",
        confidence: 87,
      },
      consumption_batch_number: {
        value: "1121557",
        confidence: 78,
      },
      quantity_units: {
        value: "kg",
        confidence: 90,
      },
    },
    {
      bowl: {
        value: "B",
        confidence: 96,
      },
      consumed_material_number: {
        value: "1800005004",
        confidence: 98,
      },
      actual_component_quantity_consumed: {
        value: "226.0",
        confidence: 86,
      },
      consumption_batch_number: {
        value: "1121557",
        confidence: 85,
      },
      quantity_units: {
        value: "kg",
        confidence: 85,
      },
    },
    {
      bowl: {
        value: "C",
        confidence: 94,
      },
      consumed_material_number: {
        value: "1800005004",
        confidence: 92,
      },
      actual_component_quantity_consumed: {
        value: "226.0",
        confidence: 92,
      },
      consumption_batch_number: {
        value: "1121557",
        confidence: 90,
      },
      quantity_units: {
        value: "kg",
        confidence: 87,
      },
    },
  ],
  document_type: "ConsumptionDetails",
  folder_name: "Patheon",
  site_name: "Toronto",
  filename: "Patheon-Toronto-ConsumptionDetails-45334779-CTYBD.pdf",
  s3_location:
    "s3://bms-processed-files/Patheon/Toronto/45334779-CTYBD/Patheon-Toronto-ConsumptionDetails-45334779-CTYBD.pdf",
};

// styling
const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));

function DigitizedConsumptionPage(props) {
  const [isEditable, setIsEditable] = useState(false);

  const [formValues, setFormValues] = useState(initialValuesFromDb);
  const [originalValues, setOriginalValues] = useState(() => 
  JSON.parse(JSON.stringify(initialValuesFromDb))
);

  const [isShowingOriginal, setIsShowingOriginal] = useState(false);
  const [editedValues, setEditedValues] = useState(initialValuesFromDb);
  const [lastSavedValues, setLastSavedValues] = useState(initialValuesFromDb);
  const [hasSavedChanges, setHasSavedChanges] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});



  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    before: "",
    after: "",
    updatedBy: "user123",
    timestamp: new Date().toLocaleString(),
  });

  const classes = useStyles();

  // useEffect(() => {
  //   setFormValues(initialValuesFromDb);
  // }, []);
  // const isFormChanged =
  //   JSON.stringify(formValues) !== JSON.stringify(originalValues);

  // const fields = [
  //   "Consumed Material Number",
  //   "Quantiy Consumed",
  //   "UoM",
  //   "Consumption Batch Number",
  // ];

 // const levels = [75, 82, 95, 67, 88, 91, 79, 93, 85, 77, 84, 96, 89];

  const getLevelColor = (level) => {
    if (level < 80) return "red";
    if (level <= 90) return "orange";
    return "green";
  };

  const handleNestedChange = (index, field, key, value) => {
    
    let isValid = true;

  // Inline filtering logic
  switch (key) {
    case "consumed_material_number":
    case "consumption_batch_number":
      isValid = /^[a-zA-Z0-9]*$/.test(value); 
      break;
    case "actual_component_quantity_consumed":
      isValid = /^\d*\.?\d*$/.test(value);
      break;
    case "quantity_units":
      isValid = /^[a-zA-Z]*$/.test(value); 
      break;
    default:
      isValid = true;
  }

  if (!isValid) return; // block invalid characters from being typed

  // Proceed with normal state update
  const updated = [...formValues[field]];
  updated[index][key].value = value;
  setFormValues({ ...formValues, [field]: updated });
  
  };
  // const isFieldChanged = (key) => {
  //   return formValues[key]?.value !== originalValues[key]?.value;
  // };

  //   const repeatableFields = [
  //     "BMS Material Number",
  //     "CMO Material Number",
  //     "BMS Material Batch Number",
  //     "CMO Material Batch Number",
  //     "Actual Component Quantity Consumed",
  //   ];

  // const validateField = (key, value) => {
  //   switch (key) {
  //     case "consumed_material_number":
  //       if (!/^[a-zA-Z0-9]*$/.test(value)) {
  //         return "Consumed Material Number must be alphanumeric";
  //       }
  //       break;
  //     case "actual_component_quantity_consumed":
  //       if (!/^\d+(\.\d+)?$/.test(value)) {
  //         return "Quantity must be a number";
  //       }
  //       break;
  //     case "quantity_units":
  //       if (!/^[a-zA-Z]+$/.test(value)) {
  //         return "UoM must contain only letters";
  //       }
  //       break;
  //     case "consumption_batch_number":
  //       if (!/^[a-zA-Z0-9]+$/.test(value)) {
  //         return "Batch Number must be alphanumeric";
  //       }
  //       break;
  //   }
  //   return "";
  // };
  
  return (
    <>
      <Grid container direction="column" spacing={2}>
        {/* Actions*/}
        <Grid item container alignItems="center">
          {/* Left Title */}
          <Grid item>
            <Typography variant="h6">
              Consumption Pages Data
            </Typography>
          </Grid>
          {/* Spacer between title and buttons */}
          <Grid item style={{ width: "78px" }} />{" "}
          {/* Edit and Show Unedited Version buttons */}
          <Grid item>
            <Box display="flex" gap={2} style={{ minWidth: "375px" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (isEditable) {
                    // Saving edits
                    setLastSavedValues(formValues);
                    //setOriginalValues(formValues);
                    setHasSavedChanges(true);
                  }
                  setIsEditable((prev) => !prev);
                }}
                style={{ minWidth: 20, textAlign: "center" }}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
              <Grid item style={{ width: "10px" }} />{" "}
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  if (!isShowingOriginal) {
                    // Switching to original view
                    setFormValues(originalValues);
                  } else {
                    // Switching back to edited view
                    setFormValues(lastSavedValues);
                  }
                  setIsShowingOriginal(!isShowingOriginal);
                  setIsEditable(false); // Always disable editing when toggling views
                }}
                style={{ minWidth: 20, textAlign: "center", size: "20px" }}
              >
                {isShowingOriginal
                  ? "Show Edited Version"
                  : "Show Unedited Version"}
              </Button>
            </Box>
          </Grid>
          <Grid item style={{ width: "10px" }} />{" "}
          <Grid item>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box mt={2}>
                {formValues.bowls.map((bowlItem, index) => (
                  <Box
                    key={index}
                    mb={3}
                    p={2}
                    border="1px solid #ccc"
                    borderRadius={8}
                    bgcolor="#f9f9f9"
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      Bowl {bowlItem.bowl.value}
                    </Typography>

                    {[
                      {
                        label: "Consumed Material Number",
                        key: "consumed_material_number",
                      },
                      {
                        label: "Quantity Consumed",
                        key: "actual_component_quantity_consumed",
                      },
                      { label: "UoM", key: "quantity_units" },
                      {
                        label: "Consumption Batch Number",
                        key: "consumption_batch_number",
                      },
                    ].map(({ label, key }) => {
                      const isChanged = !isEditable && 
                      bowlItem[key].value !== originalValues.bowls[index][key].value;
                    
                      return (
                        <Grid
                          container
                          key={key}
                          alignItems="center"
                          spacing={2}
                          className={classes.formField}
                        >
                          <Grid item xs={4}>
                            <Typography
                              style={{ paddingRight: 16, fontWeight: 500 }}
                            >
                              {label}
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              size="small"
                              value={bowlItem[key].value}
                              onChange={(e) =>
                                handleNestedChange(
                                  index,
                                  "bowls",
                                  key,
                                  e.target.value
                                )
                              }
                              onBlur={(e) => {
                                const { value } = e.target;
                                // Trim leading and trailing spaces for string values
                                if (typeof value === "string" && value.trim() !== value) {
                                  handleNestedChange(index, "bowls", key, value.trim());
                                }
                              }}
                              placeholder={`Enter ${label}`}
                              InputProps={{
                                readOnly: !isEditable,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      pl={1}
                                    >
                                      <Box
                                        style={{
                                          width: 1,
                                          height: 39,
                                          backgroundColor: "#ccc",
                                          marginRight: 3,
                                        }}
                                      />
                                      {isChanged ? (
                                        <Box
                                          onClick={() => {
                                            setModalData({
                                              field: label,
                                              before: originalValues.bowls[index][key].value,
                                              after: bowlItem[key].value,
                                              updatedBy: "user123",
                                              timestamp: new Date().toLocaleString(),
                                            });
                                            setOpenModal(true);
                                          }}
                                          style={{
                                            backgroundColor: "#7777",
                                            color: "white",
                                            borderRadius: 4,
                                            padding: "2px 8px",
                                            fontSize: "0.75rem",
                                            fontWeight: 600,
                                            minWidth: 24,
                                            textAlign: "center",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Info fontSize="small" />
                                        </Box>
                                      ) : (
                                        <Box
                                          style={{
                                            backgroundColor: getLevelColor(
                                              bowlItem[key].confidence
                                            ),
                                            color: "white",
                                            borderRadius: 4,
                                            padding: "2px 8px",
                                            fontSize: "0.75rem",
                                            fontWeight: 600,
                                            minWidth: 24,
                                            textAlign: "center",
                                          }}
                                        >
                                          {bowlItem[key].confidence ?? "-"}
                                        </Box>
                                      )}
                                    </Box>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Box>
                ))}
              </Box>

              

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} /> {/* Green Box */}
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                {/* Orange Box */}
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                {/* Red Box */}
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Right side: PDF view placeholder */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                <iframe
                  src={""}
                  //src={pdfUrl}
                  //src="https://Patheon-Toronto-CertificateOfManufacture-45420490-CVYPH.pdf"
                  title="PDF Preview"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default DigitizedConsumptionPage;
